(() => {
  function keyFor(label) {
    const metal = /yellow/i.test(label) ? 'yellow' : /rose/i.test(label) ? 'rose' : 'white';
    const match = label.match(/(\d+(?:\.\d+)?)\s*CTW/i);
    return `${metal}-gold-${Math.round(Number(match?.[1] || 1.4) * 100).toString().padStart(3, '0')}ctw-`;
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-floral-gallery]').forEach(gallery => {
      if (gallery.dataset.floralReady) return;
      const root = gallery.closest('[data-product-root]');
      const select = root?.querySelector('[data-variant-select]');
      if (!select) return;
      gallery.dataset.floralReady = 'true';
      const buttons = [...gallery.querySelectorAll('[data-floral-key]')];
      function sync() {
        const key = keyFor(select.selectedOptions[0]?.textContent || '');
        const title = root.querySelector('[data-floral-title]');
        if (title) {
          const size = key.includes('070ctw-') ? 'Petite' : key.includes('280ctw-') ? 'Grande' : 'Classic';
          title.textContent = `Lab-Grown Diamond Floral Cluster Stud Earrings, ${size}`;
        }
        buttons.forEach(button => {
          button.hidden = button.dataset.floralKey !== key;
          button.setAttribute('aria-pressed', 'false');
        });
        const hero = buttons.find(button => !button.hidden && button.dataset.floralHero === 'true');
        if (hero) hero.click();
      }
      select.addEventListener('change', sync);
      sync();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
